import React, { useRef } from "react";
import { Modal, Button, Form, FormControl } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAutoB } from "../../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";

import DateTimePicker from "react-datetime-picker";

export default function PhysicianPopup(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const { selectedRow, dataX, setUpdateFlag } = props;
  const [data, setData] = useState(null);
  const [birthdate, setBirthdate] = useState(null);
  const refForm1 = useRef(null);
  const dispatch = useDispatch();
  //----------------------------------------------------------------------
  useEffect(() => {
    if (selectedRow) {
      getData(() => {
        selectedRow.action("ready");
      });
    }
  }, [selectedRow]);
  //----------------------------------------------------------------------
  const getData = (goReady) => {
    if (selectedRow && selectedRow.row && selectedRow.row.staffid === 0) {
      setData(null);
      goReady();
      return;
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/staff/get-physician-data",
        selectedRow.row,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          setData(res.data.rows[0]);
          goReady();
        }
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };
  //----------------------------------------------------------------------
  useEffect(() => {
    data && setBirthdate(data ? new Date(data.birthdate) : new Date());
  }, [data]);

  //----------------------------------------------------------------------
  //Saving Data TO server
  const saveData = (evt) => {
    const dForm1 = new FormData(refForm1.current);
    const fData1 = Object.fromEntries(dForm1);

    // -- EDIT DATE DATA TYPE
    fData1.birthdate =
      fData1.year + "-" + fData1.month + "-" + fData1.day + " 00:00:00";
    delete fData1.year;
    delete fData1.month;
    delete fData1.day;
    // --- END

    let dataToSave = {
      ItemId: selectedRow.row["staffid"],
      SaveInfo: { ...fData1, brchid: userDetail.brchid },
      UserDetail: userDetail,
    };
    if (selectedRow.row["staffid"] === 0) {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        createby: userDetail.userid,
      };
    } else {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        updateby: userDetail.userid,
      };
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/staff/update-physician",
        dataToSave,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" })
        );
        setWinState({ show: false });
        setUpdateFlag(true);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  // FIELDS Ojbect list
  //
  const FILEDS = [
    { label: "รหัสแพทย์", oName: "staffcode", require: true, type: "text" },
    {
      label: "คำนำหน้า",
      oName: "prefixid",
      require: true,
      type: "select",
      rows: dataX && dataX.Prefix && dataX.Prefix,
    },
    { label: "ชื่อ", oName: "firstname", require: true, type: "text" },
    { label: "นามสกุล", oName: "lastname", require: true, type: "text" },
    { label: "ชื่อสั้น", oName: "nickname", require: true, type: "text" },
    {
      label: "เพศ",
      oName: "gendid",
      require: true,
      type: "select",
      rows: dataX && dataX.Gender && dataX.Gender,
    },
    {
      label: "ประเภท",
      oName: "stafftypeid",
      require: true,
      type: "select",
      rows: dataX && dataX.StaffType && dataX.StaffType,
    },
    { label: "ที่อยู่", oName: "addr", require: true, type: "text" },
    { label: "   ", oName: "addr2", require: true, type: "text" },
    { label: "Line ID", oName: "line_id", type: "text" },
    { label: "เบอร์ติดต่อ", oName: "mobile_no", type: "text" },
    { label: "อีเมล์", oName: "email", type: "text" },
    { label: "เลข ว.", oName: "cert_no", type: "text" },
    {
      label: "วันเกิด",
      oName: "birthdate",
      type: "date",
      state: [birthdate, setBirthdate],
    },
  ];
  //----------------------------------------------------------------------
  // Return Zone
  return (
    <MyModal show={winState.show} size="lg" centered backdrop={false}>
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เพิ่มแก้ไข {`${props.formName ? props.formName : "รายการ"}`}
      </ModalHeaderBlack>

      <ModalBodyBlack>
        {FILEDS ? (
          <FormAutoB
            {...{ formId: "form1", items: FILEDS, data: data, refTo: refForm1 }}
          />
        ) : null}
      </ModalBodyBlack>

      <ModalFooterBlack>
        <Button variant="primary" onClick={() => saveData()}>
          Save changes
        </Button>
        <Button variant="danger" onClick={() => setWinState({ show: false })}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}
